import { getFinishRegisterRequiredFields } from "../domain/constant/client.register.required.fields";

import { flattenObject, getMissingFields } from "../components/providers/utils.provider";

export const checkFinishRegisterFields = (data = {}, isCorporation, withAddress) => {

    const requiredFields = getFinishRegisterRequiredFields(data, isCorporation, withAddress);
    const allFields = flattenObject(data);

    return getMissingFields(allFields, requiredFields);
}

export default {
    checkFinishRegisterFields,
}
